module.exports = __webpack_public_path__ + "static/powerbi-odata-auth-4e7e24adeeca682f42669629749b099e.png";